// Only the first share of a video by a user is counted.
export const SHARE_VIDEO = `
  mutation shareVideo($input: ShareVideoInput) {
    shareVideo(input: $input) {
      videoId
      video {
        id
        shares
      }
    }
  }
`;
